// The signed-in agent's notification centre — mirrors
// packages/server/src/routes/notifications.ts.

import type { AgentNotification } from '@prakash-software/shared';
import { apiFetch } from './api';

export async function fetchNotifications(): Promise<{ notifications: AgentNotification[]; unread: number }> {
  return apiFetch('/api/notifications');
}

export async function markNotificationRead(id: string): Promise<void> {
  await apiFetch(`/api/notifications/${encodeURIComponent(id)}/read`, { method: 'POST' });
}

export async function markAllNotificationsRead(): Promise<void> {
  await apiFetch('/api/notifications/read-all', { method: 'POST' });
}
